import type { FaireProductEntity } from "../../entity_types/product";

export const p_yreqqv4xa7: FaireProductEntity = {
  token: "p_yreqqv4xa7",
  type: "product",
  name: "LM-SW-1029 Checkered TN Orange",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/025a16e37deb609c22b6aa83d8263728eaa49252d9526eeab151e968a832cd46.jpeg",
  galleryImageUrls: [],
  priceDollars: 27.5,
  description: "",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:40.212Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
